import React from 'react';
import PropTypes from 'prop-types';
import { FirstPitchWrapper, GameTimeWrapper, TitleWrapper, VenueWrapper } from './FirstPitch.style';
import Icon from '@mlb/react-patterns/v4/components/Icon/icon';
import Skeleton from '@mlb/react-patterns/v4/components/Skeleton/skeleton';
import { IconWrapper } from '../Play/play/SummaryPlayEvents.style';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';

const FirstPitch = ({
    isLoading,
    firstPitchTime,
    showImage,
    isWarmup,
    venueName
}) => {
    const label = useTranslator('game_firstpitch', 'First Pitch');
    const labelScheduled = useTranslator('game_firstpitch_scheduled', 'First Pitch Scheduled');

    return (
        <FirstPitchWrapper $showImage={showImage}>
            { showImage ? <IconWrapper isLoading={ isLoading } >
                { !isLoading ? <Icon
                    name={ 'baseball-3' }
                    width='24'
                /> : <Skeleton width='52px' height='52px' isCircle={true}/> }
            </IconWrapper> : null }
            <div>
            {!isLoading
                ?
                    <>
                        <TitleWrapper>{ !isWarmup ? label : labelScheduled }</TitleWrapper>
                        <GameTimeWrapper >{ firstPitchTime }</GameTimeWrapper>
                        <VenueWrapper>{venueName}</VenueWrapper>
                    </>
                :   <><Skeleton height='18px' width='100px' /><Skeleton height='18px' width='100px' /></>
            }
            </div>
        </FirstPitchWrapper>
    );
};

FirstPitch.propTypes = {
    isLoading: PropTypes.bool,
    firstPitchTime: PropTypes.string,
    showImage: PropTypes.bool,
    isWarmup: PropTypes.bool,
    venueName: PropTypes.string
};

export default FirstPitch;
